import type { UUID } from '@aline/common';
import { makeVar } from '@apollo/client';

/**
 * Active AI chat thread id, shared across surfaces (editor drawer, dashboard chat, chat mentions).
 * Lives in its own leaf module so consumers like the chat editor's MentionElement can read it
 * without importing a component file and creating an import cycle through the chat barrels.
 */
export const aiThreadIdVar = makeVar<UUID | null>(null);
